<mat-accordion multi class="expand-collapse-panel">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
    </mat-expansion-panel-header>
    <form autocomplete="off" [formGroup]="form" id="filterCustomerFacilityManager" class="filter-form">
      <div class="filter-field">
        <mat-form-field class="search-input">
          <mat-label>Customer Id</mat-label>
          <input placeholder="Customer Id"
            matInput
            [matChipInputFor]="chipCustomerId"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="applyFilter($event, 'customerids')">
          </mat-form-field>
          <mat-chip-grid #chipCustomerId>
            @for (item of customerIds; track item) {
              <mat-chip-row
                [removable]="removable" (removed)="remove(item, 'customerids')">
                {{item}}
                @if (removable) {
                  <mat-icon matChipRemove>cancel</mat-icon>
                }
              </mat-chip-row>
            }
          </mat-chip-grid>
        </div>
        <div class="filter-field">
          <mat-form-field class="search-input">
            <mat-label>Facilities Manager Id</mat-label>
            <input placeholder="Facilities Manager Id"
              matInput
              [matChipInputFor]="chipFacilityManagerIds"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="applyFilter($event, 'facilitymanagerids')">
            </mat-form-field>
            <mat-chip-grid #chipFacilityManagerIds>
              @for (item of facilityManagerIds; track item) {
                <mat-chip-row
                  [removable]="removable" (removed)="remove(item, 'facilitymanagerids')">
                  {{item}}
                  @if (removable) {
                    <mat-icon matChipRemove>cancel</mat-icon>
                  }
                </mat-chip-row>
              }
            </mat-chip-grid>
          </div>
          <div class="filter-actions">
            <button type="button" class="btn mat-flat-button btn-primary" (click)="onFilter()">
              {{ changeTypeButton() ? 'Reset' : 'Filter' }}
            </button>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>